import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchPermissionList(filter) {
  return request({
    url: '/api/permissions',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function updatePermission(id, data) {
  return request({
    url: '/api/permissions/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}
